import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { postAuth } from "../auth/postAuth";
import "./LoginPage.css";
import logo from "../Assets/logo.png";
import Sidebar from "./sidebar";
import Footer from "./Footer";

const PASSWORD_CRITERIA = `Password criteria:
• Six or more characters
• One special character
• No spaces allowed
• One uppercase character`;

function passwordError(password) {
  if (!password || password.length < 6) {
    return "Password must have six or more characters.";
  }
  if (/\s/.test(password)) {
    return "Password must not contain spaces.";
  }
  if (!/[^A-Za-z0-9]/.test(password)) {
    return "Password must contain at least one special character.";
  }
  if (password === password.toLowerCase()) {
    return "Password must contain at least one uppercase character.";
  }
  return "";
}

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = (params.get("token") || "").trim();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!token) {
      setError("This reset link is missing its token. Request a new one from the sign-in page.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    const criteriaError = passwordError(password);
    if (criteriaError) {
      setError(criteriaError);
      return;
    }

    setSubmitting(true);
    try {
      const data = await postAuth("/auth/reset.php", { token, password });
      setSuccess(data?.message || "Your password has been updated. You can sign in now.");
      setPassword("");
      setConfirm("");
    } catch (err) {
      setError(err.message || "Could not reset the password.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="tm-login-shell tm-login-shell--desktop-offset">
        <Sidebar />
        <div className="tm-login-brand">
          <div className="tm-logo">
            <img src={logo} alt="Custom Logo" />
            <div className="header-info">
              <p className="company-name">Table Mate</p>
              <p className="site-title">Back End Server Application</p>
            </div>
          </div>
          <div className="tm-login-brand-copy">
            <div className="tm-login-brand-heading">Data Centre Login</div>
            <p className="tm-login-brand-body">
              Secure access to your sales, tables, ratings, and menu analytics.
            </p>
          </div>
        </div>

        <div className="tm-login-main">
          <div className="tm-login-card">
            <h1 className="tm-login-title">Set your password</h1>
            <p className="tm-login-subtitle">
              Choose a new password for your Data Centre account. This link expires after 24 hours.
            </p>

            {error && <div className="tm-login-error">{error}</div>}
            {success && <div className="tm-login-success">{success}</div>}

            {success ? (
              <Link to="/login" className="tm-login-button">
                Sign in
              </Link>
            ) : (
              <form onSubmit={handleSubmit} className="tm-login-form">
                <p className="tm-login-criteria">{PASSWORD_CRITERIA}</p>
                <div className="tm-login-field">
                  <label htmlFor="password" className="tm-login-label">
                    New password
                  </label>
                  <input
                    id="password"
                    type="password"
                    className="tm-login-input"
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="tm-login-field">
                  <label htmlFor="confirm" className="tm-login-label">
                    Confirm password
                  </label>
                  <input
                    id="confirm"
                    type="password"
                    className="tm-login-input"
                    autoComplete="new-password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="tm-login-button"
                  disabled={submitting}
                >
                  {submitting ? "Saving..." : "Save password"}
                </button>
                <Link to="/forgot-password" className="tm-login-forgot">
                  Request a new link
                </Link>
              </form>
            )}
          </div>

          <div className="tm-login-footer">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}
